import React, { useEffect, useState } from "react";
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import { useMoralis } from 'react-moralis';
import UserIdenticon from '../commons/UserIdenticon';
import { Link } from "@reach/router";
import { useWeb3React } from '@web3-react/core';
import { toast } from 'react-toastify'
import { DateTime } from "luxon";
import axios from "axios";
import { CopyToClipboard } from 'react-copy-to-clipboard'

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const ProfileEdit = ({ walletAddress }) => {

  const { Moralis, isInitialized } = useMoralis()
  const { account, active } = useWeb3React()
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [isProfileUpdating, setIsProfileUpdating] = useState(false)
  const [profileData, setProfileData] = useState({})
  const [username, setUsername] = useState('')
  const [bio, setBio] = useState('')
  const [isValidProfile, setIsValidProfile] = useState(false)

  const [profileImage, setProfileImage] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState(null)
  const [isProfileImageUploading, setIsProfileImageUploading] = useState(false)
  const [copied, setCopied] = useState(false)


  const getUserImage = (moralisAttributes, imageSize = 50) => {

    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image" src={profileImageUrl} alt="" />
      } else {
        return <UserIdenticon size={imageSize} walletAddress={moralisAttributes.walletAddress} />
      }
    } else {
      return <UserIdenticon size={imageSize} walletAddress={walletAddress} />
    }
  }

  const uploadFileToIPFS = async (file) => {
    console.log('file data', file)
    const endpoint = 'https://api.pinata.cloud/pinning/pinFileToIPFS'
    const pinataAPIKey = process.env.REACT_APP_PINATA_API_KEY
    const pinataAPISecret = process.env.REACT_APP_PINATA_SECRET_KEY

    const dt = DateTime.now()
    const newFileName = dt.toMillis() + "_" + file.name
    let data = new FormData();
    data.append('file', file);

    const metadata = JSON.stringify({
      name: newFileName,
      keyvalues: {
        h4gProfiles: 'marketplace-profile' + newFileName
      }
    });
    data.append('pinataMetadata', metadata);

    const response = await axios.post(endpoint, data, {
      maxBodyLength: 'Infinity', //this is needed to prevent axios from erroring out with large files
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: pinataAPIKey,
        pinata_secret_api_key: pinataAPISecret
      }
    })

    if (response.status === 200) {
      return response.data.IpfsHash
    } else {
      return null
    }
  }

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return moralisAttributes.username
      } else {
        return '@Unnamed'
      }
    } else {
      return '@Unnamed'
    }

  }

  useEffect(() => {
    if (active && (account === walletAddress)) {
      setIsValidProfile(true)
    } else {
      setIsValidProfile(false)
    }
  }, [walletAddress, account, active])

  const getCreatorProfileData = async () => {
    try {
      setIsLoadingProfile(true)
      const params = { walletAddress };
      const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
      console.log('profileDataResponse', profileDataResponse)
      setProfileData(profileDataResponse)
      setUsername(profileDataResponse ? profileDataResponse.attributes.username : '')
      setBio(profileDataResponse ? profileDataResponse.attributes.bio : '')
      setIsLoadingProfile(false)
    } catch (error) {
      setIsLoadingProfile(false)
      setProfileData({})
      console.error("MORALIS : error while fetching profile data ", error)

    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (isInitialized) {
      await getCreatorProfileData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const handleProfileUpdate = async () => {

    if (!isValidProfile) {
      toast.dark('Please connect your wallet with to edit your profile', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }

    if (isInitialized) {
      try {
        setIsProfileUpdating(true)
        const Creator = Moralis.Object.extend("Creators")
        const query = new Moralis.Query(Creator)
        query.equalTo('walletAddress', walletAddress)
        query.limit(1)
        const users = await query.find()

        if (users && users.length > 0) {
          const user = users[0]
          user.set('username', username)
          user.set('bio', bio)
          await user.save()
        }
        setIsProfileUpdating(false)
        toast.dark('Profile has been updated', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setBio('')
        setUsername('')
        await getCreatorProfileData()
      } catch (error) {
        setIsProfileUpdating(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

  }

  const onImageChange = async (e) => {
    try {
      setIsProfileImageUploading(true)
      const fileData = e.target.files[0]
      const ipfsHash = await uploadFileToIPFS(fileData)
      await updateProfileCID(ipfsHash)
      setProfileImage(fileData)
      setIsProfileImageUploading(false)

    } catch (error) {
      console.error('Error while uploading file profile image', error)
      setIsProfileImageUploading(false)
    }

  };

  const updateProfileCID = async (cid) => {
    if (isInitialized) {
      try {

        const Creator = Moralis.Object.extend("Creators")
        const query = new Moralis.Query(Creator)
        query.equalTo('walletAddress', walletAddress)
        query.limit(1)
        const users = await query.find()

        if (users && users.length > 0) {
          const user = users[0]
          user.set('profileImageCID', cid)
          await user.save()
        }

        toast.dark('Profile image has been updated', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setProfileImageUrl(null)
        setProfileImage(null)
        await getCreatorProfileData()
      } catch (error) {
        setProfileImageUrl(null)
        setProfileImage(null)
        console.error('MORALIS ERROR : error while updating profile image', error)
      }
    }
  }

  useEffect(() => {
    if (profileImage) {
      const profileImageURLData = URL.createObjectURL(profileImage)
      setProfileImageUrl(profileImageURLData)
    }

  }, [profileImage])

  const onCopy = () => {
    setCopied(true)
    if (copied) {
      toast.dark('Wallet address copied!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
    <div>
      <GlobalStyles />
      <section className='jumbotron breadcumb no-bg'>
      </section>
      {
        isLoadingProfile ? (
          <div className="row mb-4 mt-4">
            <div className='col-lg-12'>
              <div className='loading-container mb-4'>
                <div className="spinner-grow" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        ) :
          (
            <section className='container no-bottom'>
              <div className='row'>
                <div className="col-md-12">
                  <div className="d_profile de-flex">
                    <div className="de-flex-col">
                      <div className="profile_avatar">
                        {profileImageUrl ?
                          (<img className="profile-image" src={profileImageUrl} alt="" />) :
                          (getUserImage(profileData.attributes, 150))
                        }

                        <div className="profile_name">
                          <h4>
                            {/* {getUsername(profileData?.attributes)} */}
                            <span className="profile_username">{getUsername(profileData ? profileData.attributes : null)}</span>
                            <span id="wallet" className="profile_wallet">{walletAddress}</span>
                            <CopyToClipboard onCopy={onCopy} text={walletAddress}>
                              <button id="btn_copy" title="Copy Text">Copy</button>
                            </CopyToClipboard>
                            <div className="profile_edit">

                              {
                                isProfileImageUploading ?
                                  (
                                    <div className="spinner-grow" role="status">
                                      <span className="sr-only">Loading...</span>
                                    </div>
                                  ) :
                                  (
                                    <div>
                                      <label htmlFor="files" className="btn-main profile-image-upload-btn">
                                        Update profile image
                                      </label>
                                      <input
                                        style={{ visibility: 'hidden' }}
                                        id="files"
                                        type="file"
                                        multiple
                                        onChange={onImageChange}
                                        accept="image/*"
                                      />
                                    </div>
                                  )
                              }



                              {/* <button className="btn-main profile-image-upload-btn">
                                
                              </button> */}
                            </div>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <h5>Username</h5>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="form-control"
                    placeholder="Enter your username" />
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12">
                  <h5>Bio</h5>
                  <textarea
                    data-autoresize
                    onChange={(e) => setBio(e.target.value)}
                    name="bio"
                    id="bio"
                    value={bio}
                    className="form-control"
                    placeholder="e.g. 'I am a ...'"></textarea>
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12 mb-4">

                  {
                    isProfileUpdating ?
                      (
                        <div className='loading-container mb-4'>
                          <div className="spinner-grow" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) :
                      (
                        <button id="submit" className="btn-main" onClick={handleProfileUpdate}>
                          Update Profile
                        </button>
                      )
                  }

                </div>

              </div>
            </section>
          )
      }
      <Footer />
    </div >
  );
}
export default ProfileEdit;